// import { useParams } from 'react-router-dom'

import { useParams } from 'react-router-dom'

import { IGAO } from '../../../igao'

import { DeliveredContextProvider } from './components/delivered-context'
import { CurrentPregnancyForm } from './current-pregnancy/current-pregnancy-form'
import { useCurrentPregnancy } from './current-pregnancy/queries'
import { DeliveryHistory } from './delivery-history/delivery-history-form'
import { ObstetricalHistoryForm } from './obstetrical-history/obstetrical-form'
import { useObstetricalHistory } from './obstetrical-history/queries'

const ERROR_MESSAGE = 'Error: LMP or Delivered, Gravida and Para must have positive values before you can Publish this page.'

export default function MaternityContainer (): JSX.Element {
  const { id } = useParams()
  const obstetricalQuery = useObstetricalHistory(id)
  const currentPregnancy = useCurrentPregnancy(id)

  const allRelativeSubmited =
      obstetricalQuery.data?.draft === false &&
      currentPregnancy.data?.draft === false && (currentPregnancy.data?.data?.lmp ?? currentPregnancy.data?.data?.delivered)

  return (
    <div className='main'>
      <DeliveredContextProvider>
        <CurrentPregnancyForm />
        <ObstetricalHistoryForm />
        <DeliveryHistory />
      </DeliveredContextProvider>

      <IGAO
        path='maternity'
        // @ts-expect-error //it's okay
        error={!allRelativeSubmited ? ERROR_MESSAGE : null}
        disabled={!allRelativeSubmited}
      />
    </div>
  )
}
